import { render, staticRenderFns } from "./OrderAttachment.vue?vue&type=template&id=51b08e5e&scoped=true&"
import script from "./OrderAttachment.vue?vue&type=script&lang=js&"
export * from "./OrderAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b08e5e",
  null
  
)

export default component.exports